<template>
  <v-layout row wrap fill-width>
    <DateRange box no-arrows v-model="dates" :max-date="maxDate" />
  </v-layout>
</template>
<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import CustomDateTimePicker from '@/components/CustomDateTimePicker'
  import CustomDateRangePickerManualTimeSeries from '@/components/CustomDateRangePickerManualTimeSeries'

  import {
    TimeFilter,
  } from '@/components/plugins/DataSetFilter'

  import DateRange from '@/components/generic/DateRange'

  const datasetfilter = createNamespacedHelpers('datasetfilter')

  export default {
    components: {
      DateRange,
      'date-time-picker': CustomDateTimePicker,
      'date-range-picker-manual': CustomDateRangePickerManualTimeSeries,
    },
    data() {
      return {
        dates: {
          start: null,
          end: null,
        },
        maxDate: new Date(),
      }
    },
    watch: {
      dates: {
        deep: true,
        handler(dates) {
          this.submit(dates)
        },
      },
    },
    methods: {
      ...datasetfilter.mapActions(['addFilter']),
      handleReturn() {
        this.reset()
        this.$emit('returnEvent', 'time')
      },
      reset() {
        this.$refs['navigation-date-picker'].reset()
      },
      submit({
        start,
        end,
      }) {        
        let filter = new TimeFilter(start, end)
        this.addFilter(filter)
        this.$emit('instantSearchEvent', 'time')
      },
    },
  }
</script>
